module.exports = __webpack_public_path__ + "img/icon_advocate@2x.bc99412b.png";